// extracted by mini-css-extract-plugin
module.exports = {"question":"FAQs-module__question___2c1Z-","answer":"FAQs-module__answer___3gBNM"};